import { Button } from "@/components/ui/button";
import { MapLocation } from '@/types/location';
import { useLanguage } from "@/contexts/LanguageContext";
import { ShoppingCart, X, Wrench } from 'lucide-react';

interface ActionButtonsProps {
  location: MapLocation;
  isSelected: boolean;
  onSelectButtonClick: () => void;
  isMobile?: boolean;
}

export const ActionButtons = ({
  location,
  isSelected,
  onSelectButtonClick,
  isMobile = false
}: ActionButtonsProps) => {
  const { t } = useLanguage();
  const isAttentionLocation = location.mediaOwner === 'Attention';
  const isInMaintenance = location.maintenanceStatus === 'maintenance' || location.maintenanceStatus === 'offline';

  if (isInMaintenance) {
    return (
      <Button
        disabled
        className={`w-full rounded-xl ${isMobile ? 'h-12 text-base' : 'h-10'} font-semibold opacity-60 cursor-not-allowed`}
        variant="secondary"
      >
        <Wrench className="h-4 w-4 mr-2" />
        Under Maintenance
      </Button>
    );
  }

  const getButtonText = () => {
    if (isAttentionLocation) {
      return isSelected ? t("removeLocation") : t("bookScreens");
    } else {
      return isSelected ? t("deselectLocation") : t("selectLocation");
    }
  };

  const handleButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();
    onSelectButtonClick();
  };

  if (isSelected) {
    return (
      <Button
        onClick={handleButtonClick}
        variant="destructive"
        className={`w-full rounded-xl ${isMobile ? 'h-12 text-base' : 'h-10'} font-semibold transition-all duration-200 hover:scale-[1.02] active:scale-[0.98]`}
      >
        <X className="h-4 w-4 mr-2" />
        {getButtonText()}
      </Button>
    );
  }

  return (
    <Button
      onClick={handleButtonClick}
      className={`w-full rounded-xl ${isMobile ? 'h-12 text-base' : 'h-10'} font-semibold bg-gradient-to-r from-primary to-primary/80 hover:from-primary/90 hover:to-primary/70 transition-all duration-200 hover:scale-[1.02] active:scale-[0.98] shadow-sm`}
    >
      <ShoppingCart className="h-4 w-4 mr-2" />
      {getButtonText()}
    </Button>
  );
};
